/**
 * AjudaPermissao — o "?" de cada permissão na Gestão de Acessos.
 *
 * Conteúdo vem do backend (`permissoes/ajuda`, campo `ajuda` do catálogo):
 * o que a permissão libera, um exemplo prático e o que costuma andar junto.
 * Sem texto próprio, mostra a descrição do catálogo — o "?" nunca abre vazio.
 */
import React from "react";

import BalaoAjuda from "../BalaoAjuda";
import { rotuloPermissao } from "./arvore.js";
import { AjudaMeta, AjudaSituacao } from "./styles.jsx";

const SITUACAO = {
  checked: "Liberada diretamente aqui.",
  inherited: "Vem do cargo. Quem está neste cargo já tem esta permissão.",
  revoked: "Vem do cargo, mas foi negada só para esta pessoa.",
  off: "Não liberada.",
};

function AjudaPermissao({ permissao: p, estado, onde, indice }) {
  const rotulo = rotuloPermissao(p);
  const explicacao = p.ajuda?.explicacao || p.descricao;
  const relacionados = (p.ajuda?.veja_tambem || [])
    .map((codigo) => indice?.[codigo]?.permissao)
    .filter(Boolean);

  return (
    <BalaoAjuda
      titulo={rotulo}
      rotuloGatilho={`O que é: ${rotulo}`}
      rotuloBalao={`Ajuda: ${rotulo}`}
      dica="O que esta permissão libera"
    >
      {explicacao ? (
        <section>
          <h4>O que libera</h4>
          <p>{explicacao}</p>
        </section>
      ) : null}
      {p.ajuda?.exemplo ? (
        <section>
          <h4>Exemplo prático</h4>
          <p>{p.ajuda.exemplo}</p>
        </section>
      ) : null}
      {relacionados.length ? (
        <section>
          <h4>Costuma andar junto com</h4>
          <ul>
            {relacionados.map((r) => (
              <li key={r.codigo}>{rotuloPermissao(r)}</li>
            ))}
          </ul>
        </section>
      ) : null}
      {p.requer_mfa ? (
        <section className="explicacao-card__atencao">
          <h4>Atenção</h4>
          <p>
            Ação sensível: na hora de usar, o sistema pede o código do
            aplicativo autenticador (MFA) de quem está fazendo.
          </p>
        </section>
      ) : null}
      {estado ? <AjudaSituacao>{SITUACAO[estado]}</AjudaSituacao> : null}
      <AjudaMeta>
        {onde ? <span>Onde fica: {onde}</span> : null}
        <span>
          Código técnico: <code>{p.codigo}</code>
        </span>
      </AjudaMeta>
    </BalaoAjuda>
  );
}

export default AjudaPermissao;
